<template>
  <div
    :class="{
      'is-required': field.required
    }"
  >
    <el-input
      v-bind="$attrs"
      v-model.lazy="localModel"
      :ref="field.name"
      :name="field.name"
      :required="field.required || required"
      :placeholder="field.placeholder || $attrs.placeholder"
      :disabled="field.disabled"
      :readonly="field.readonly"
      type="textarea"
      :maxlength="Number(field.maxlength || field.len || $attrs.maxlength)"
      :autosize="type == 'communication' ? { minRows: 1, maxRows: 10 } : true"
      @change.native="changeValue"
      @input.native="changeValue"
      :class="
        ('el-textarea--no-resize-icon',
        {
          'is-error': !!field.error,

          'no-label': !!$attrs['no-label'],
          'communication-textarea': type == 'communication'
        })
      "
    >
    </el-input>
    <!-- <div v-if="field.required && !$attrs['no-label']" class="red-star">
      поле обязательно
    </div> -->
  </div>
</template>

<script>
import { Input } from 'element-ui';
export default {
  inheritAttrs: false,
  data() {
    return {
      localModel: this.model || ''
    };
  },
  props: {
    field: {
      type: Object,
      default: () => ({
        name: '',
        required: false,
        placeholder: '',
        disabled: false
      })
    },
    model: {
      type: String,
      default: ''
    },
    hasResizeIcon: {
      type: Boolean,
      default: true
    },
    hiddenResizeIcon: {
      type: Boolean,
      default: false
    },
    emitEvent: { type: String, default: 'change' },
    required: {
      type: Boolean,
      default: false
    },
    type: { type: String, default: '' }
  },
  mounted() {
    if (this.$listeners['set-hidden']) {
      this.$emit('set-hidden', this.field.name, false);
    }
  },
  methods: {
    changeValue: function () {
      this.$emit(this.emitEvent, this.field.name, this.localModel);
    }
  },
  watch: {
    model: function () {
      this.localModel = this.model || '';
    }
  },
  destroyed() {
    if (this.$listeners['set-hidden']) {
      this.$emit('set-hidden', this.field.name, true);
    }
  },
  components: { 'el-input': Input }
};
</script>

<style lang="scss" scoped>
.el-textarea {
  &--no-resize-icon:after {
    content: '';
    width: 28px;
    height: 28px;
    background-color: $white !important;
    background-image: none !important;
    display: inline-block;
    position: absolute;
    bottom: 1px;
    right: 1px;
    pointer-events: none;
  }

  &--no-resize-icon.is-disabled:after {
    background-color: $black-10 !important;
  }

  & ::v-deep &__inner {
    border-radius: 4px;
    color: $black-200;
    border: 1px solid $grey16;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    line-height: 18.75px;
    min-height: 64px;
    max-height: 189px;
    padding: 7px 11px 25.75px 11px;
    word-break: break-word;

    &:hover {
      border-color: $black-100;
    }
  }

  &.is-disabled.el-textarea {
    opacity: 1;

    &--resize-icon::after {
      display: none;
      background-color: $black-10;
      background-image: url('/front/public/style/img/resizer-disabled.svg');
    }
  }

  &.is-disabled .el-textarea__inner {
    background-color: $black-10;
    border-color: $black-30;
    color: $black-80;
  }
}

.communication-textarea {
  & ::v-deep .el-textarea__inner {
    max-height: unset !important;
    padding: 8px 12px !important;
    min-height: 40px !important;
  }
}

.el-input {
  & ::v-deep &__inner {
    border-radius: 4px;
    color: $black-190;
    font-family: 'Roboto', sans-serif;
    min-height: 64px;
  }
}

.is-error {
  &:not(:hover) {
    .el-textarea--no-resize-icon:after {
      background: $red16 !important;
    }
  }
}

.is-error {
  &:not(:hover) {
    .el-textarea--no-resize-icon:after {
      background: $red16 !important;
    }
  }
}

// .is-required {
//   position: relative;

//   & ::v-deep .el-textarea textarea {
//     padding-bottom: 24px;
//   }

//   .red-star {
//     color: $red-700;
//     font-size: 14px;
//     line-height: 24px;
//     position: absolute;
//     padding-left: 24px;
//     bottom: 4px;
//     left: 12px;
//     z-index: 1;
//     pointer-events: none;

//     &:before {
//       content: '';
//       width: 24px;
//       height: 24px;
//       display: inline-block;
//       background-image: url(/front/public/style/img/required-star.svg);
//       background-repeat: no-repeat;
//       background-position: 50%;
//       position: absolute;
//       top: 50%;
//       left: 0;
//       margin-top: -12px;
//     }
//   }
// }
</style>
